const DEFAULT_TIMEOUT = 60 * 1000; // 60 seconds

class HttpClient {
  constructor(baseUrl, callback) {
    this.baseUrl = baseUrl;
    this.callback = callback;
  }

  static serialize(data) {
    return Object.keys(data)
      .map(function (keyName) {
        let value = data[keyName];
        if (typeof value === 'boolean') {
          value = value ? 'true' : 'false';
        } else {
          value = value || '';
        }
        return encodeURIComponent(keyName) + '=' + encodeURIComponent(value);
      })
      .join('&');
  }

  static createError(name, message) {
    let error = new Error(message);
    error.name = name;
    return error;
  }

  // Returns a new promise object that
  // resolve with a json object on good api call or reject with an error object on failure
  // This method provide timeout functionality that fetch API lacks
  // and provides a simpler way to api consumer to determine success and failure api request
  // by handling success request in promise's onFulfilled and failure in onRejected callback.
  fetchJSON(path, opts = {}) {
    let url = this.baseUrl + path;

    opts.method = opts.method || 'GET';
    opts.headers = opts.headers || new Headers();
    opts.headers.append('Content-Type', 'application/json');

    opts.qs = opts.qs || {};

    // backward compatible to allow params as query string
    if (typeof opts.params === 'object' && Object.keys(opts.params).length > 0) {
      // merge both params and qs
      // and qs take precedence - overwrite if there is same key
      opts.qs = { ...opts.params, ...opts.qs };
    }

    if (this.callback) {
      let { token, uid } = this.callback();
      if (token) {
        opts.headers.append('Authorization', `Bearer ${token}`);
      }
      if (uid) {
        opts.qs._uid = uid; // always pass in uid for all request for tracking
      }
    }

    // our timeout variable to invoke promise's reject callback to force network timeout
    opts.timeout = opts.timeout || DEFAULT_TIMEOUT;

    if (typeof opts.qs === 'object' && Object.keys(opts.qs).length > 0) {
      url = url + '?' + HttpClient.serialize(opts.qs);
    }

    let timeout = opts.timeout || DEFAULT_TIMEOUT;
    delete opts.timeout;

    // for chrome developer console as ios/native code doesn't support cors
    // “cors” will allow requests for assets on the same-origin and other origins
    // which return the appropriate CORs headers.
    opts.mode = opts.mode || 'cors';

    // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
    let request = new Request(url, opts);
    let fetchPromise = fetch(request);

    // https://developer.mozilla.org/en-US/docs/Mozilla/JavaScript_code_modules/Promise.jsm/Deferred
    // https://developer.mozilla.org/en-US/docs/Mozilla/JavaScript_code_modules/Promise.jsm/Promise#Constructor
    let promise = new Promise((resolve, reject) => {
      let timeoutObject;

      if (timeout) {
        timeoutObject = setTimeout(() => {
          let message = 'Network request timed out!';
          let error = HttpClient.createError('NetworkTimeoutError', message);
          error.statusCode = 0;
          reject(error);
        }, timeout);
      }

      fetchPromise
        .then((resp) => {
          clearTimeout(timeoutObject);
          if (resp.ok) {
            // https://developer.mozilla.org/en-US/docs/Web/API/Response/ok
            // https://developer.mozilla.org/en-US/docs/Web/API/Body/json
            resp
              .json()
              .then((data) => {
                //console.log(url, '=>', JSON.stringify(data));
                resolve(data, resp);
              })
              .catch((err) => {
                err.message = 'Error parsing json for response of ' + path + ' ' + err.message;
                reject(err);
              });
          } else {
            resp
              .json()
              .then((data) => {
                let message = data.msg || (resp.status + ' ' + resp.statusText);
                let error = HttpClient.createError('StatusNotOkError', message);
                error.data = data;
                error.statusCode = resp.status;
                reject(error);
              })
              .catch((err) => {
                err.message = 'Error parsing json for response of ' + path + ' ' + err.message;
                reject(err);
              });
          }
        })
        .catch((err) => {
          clearTimeout(timeoutObject);
          reject(err);
        });
    });

    return promise;
  }
}

export default HttpClient;



// WEBPACK FOOTER //
// ./src/HttpClient.js